import { motion } from "framer-motion";

export default function Header({ t, lang, onToggleLang, onNavigate, onEnquire }) {
  return (
    <motion.header
      data-testid="header-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
      className="fixed top-0 left-0 right-0 z-50 bg-ivory/85 backdrop-blur-md border-b border-pine/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="brand-home-link"
          onClick={() => onNavigate("top")}
          className="font-serif text-xl md:text-2xl tracking-tight text-pine hover:text-terracotta transition-colors duration-300"
        >
          Bron Menai
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {t.nav.links.map((link) => (
            <button
              key={link.id}
              data-testid={`nav-link-${link.id}`}
              onClick={() => onNavigate(link.id)}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-pine/70 hover:text-terracotta transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <div className="flex items-center font-mono text-[11px] tracking-[0.2em]" data-testid="lang-toggle">
            <button
              data-testid="lang-toggle-en"
              onClick={() => onToggleLang("en")}
              className={`px-2 py-1 transition-colors duration-300 ${lang === "en" ? "text-terracotta" : "text-pine/40 hover:text-pine"}`}
            >
              EN
            </button>
            <span className="text-pine/20">/</span>
            <button
              data-testid="lang-toggle-cy"
              onClick={() => onToggleLang("cy")}
              className={`px-2 py-1 transition-colors duration-300 ${lang === "cy" ? "text-terracotta" : "text-pine/40 hover:text-pine"}`}
            >
              CY
            </button>
          </div>
          <button
            data-testid="header-enquire-btn"
            onClick={() => onEnquire("stay")}
            className="bg-pine text-ivory font-mono text-[11px] uppercase tracking-[0.2em] px-5 py-2.5 hover:bg-terracotta transition-colors duration-300"
          >
            {t.nav.enquire}
          </button>
        </div>
      </div>
    </motion.header>
  );
}
